<div class="roomHeader">
    <div class="headBlock">
        <p class="textLeft" >Anderson Center</p>
        <h3>F-3</h3>
    </div>
    <div class="headBlock">
        <p class="textCenter">Surgery Time</p>
        <h3>2:30 - 6:30</h3>
    </div>
    <div class="headBlock">
        <p class="textRight">Tuesday, 27 April 2021</p>
        <h3 class="textRight" >4:27 <span>PM</span></h3>
    </div>
</div>
<div class="roomWrapper">
    <div class="roomIntro">
        <div class="introBlock">
            <p>Surgeon</p>
            <h3>MattMcalpin</h3>
        </div>
        <div class="introBlock">
            <p>Patient</p>
            <h3>Johan Deo</h3>
        </div>
        <div class="introBlock">
            <p>Procedure</p>
            <h3>Debridement of wound, burn or infection.</h3>
        </div>
    </div>
    <div class="roomTaskDetail">
        <mat-tab-group mat-align-tabs="center">
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon" color="primary" >check_box</mat-icon>
                Room Prep
              </ng-template>
              <div class="detailholder">
                  <div class="tdetail">

                    <div class="lisBlockHolder">
                      <div class="listBlock">

                        <div class="theading">Task</div>
                        <div class="tlist">
                          <button mat-icon-button color="primary" ><mat-icon>task_alt</mat-icon></button> 
                          Check all power in OR room.
                        </div>
                        <div class="tlist">
                          <button mat-icon-button color="basic" ><mat-icon>task_alt</mat-icon></button> 
                          Check all the equipments are working fine.
                        </div>
                        <div class="tlist">
                          <button mat-icon-button color="basic" ><mat-icon>task_alt</mat-icon></button> 
                          Room should be clean.
                        </div>
  
                      </div>                    
  
                      <div class="listBlock">
                        <div class="theading">Equipments</div>
                        <div class="tlist">
                          <button mat-icon-button color="primary" ><mat-icon>task_alt</mat-icon></button> 
                          Dermatology Equipment.
                        </div>
                        <div class="tlist">
                          <button mat-icon-button color="basic" ><mat-icon>task_alt</mat-icon></button> 
                          Anaesthesia Machine
                        </div>
                        <div class="tlist">
                          <button mat-icon-button color="basic" ><mat-icon>task_alt</mat-icon></button> 
                          Suction Machine
                        </div>
                      </div>
                    </div>


                    <div class="actbtn">                      
                      <button mat-stroked-button color="primary" (click)="addPasscode(passcode)" >Submit</button>
                      <a href="javascript:void(0)"  (click)="reportIssue(report)" class="report">Report an issue</a>
                      <button mat-button color="warn" class="emergency" >EMERGENCY</button>
                    </div>

                  </div>
                  <div class="ttimer">

                    <div class="timeHolder">
                      <div class="time">
                        <label>Actual Time Taken</label>
                        <p>00:15:00</p>
                    </div>

                    <div class="time remaining">
                        <label>Time Remaining</label>
                        <p>00:30:00</p>
                    </div>
                    </div>


                    <div class="actbtn">
                      <button mat-stroked-button color="primary" class="start">Start/Pause</button>
                      <button mat-stroked-button color="primary" >Complete</button>
                    </div>

                  </div>
              </div>
            </mat-tab>
          
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon">check_box</mat-icon>
                Surgery
              </ng-template>
              
              <div class="detailholder">
                <div class="tdetail">

                  <div class="lisBlockHolder">
                    <div class="listBlock">

                      <div class="theading">Surgery Staff</div>
                      <div class="tlist">
                        <button mat-icon-button color="primary" ><mat-icon>task_alt</mat-icon></button> 
                        <div class="introBlock">
                          <p>Surgeon</p>
                          <h3>MattMcalpin</h3>
                      </div>
                      </div>
                      <div class="tlist">
                        <button mat-icon-button color="basic" ><mat-icon>task_alt</mat-icon></button> 
                        <div class="introBlock">
                          <p>Astt. Surgeon</p>
                          <h3>Walaysonki</h3>
                      </div>
                      </div>
                      <div class="tlist">
                        <button mat-icon-button color="basic" ><mat-icon>task_alt</mat-icon></button> 
                        <div class="introBlock">
                          <p>Nurse</p>
                          <h3>Emmalene</h3>
                      </div>
                      </div>

                    </div>                    

                   
                  </div>


                  <div class="actbtn">                      
                    <button mat-stroked-button color="primary" (click)="addPasscode(passcode)" >Submit</button>
                    <a href="javascript:void(0)"  (click)="reportIssue(report)" class="report">Report an issue</a>
                    <button mat-button color="warn" class="emergency" >EMERGENCY</button>
                  </div>

                </div>
                <div class="ttimer">

                  <div class="timeHolder">
                    <div class="time">
                      <label>Actual Time Taken</label>
                      <p>00:15:00</p>
                  </div>

                  <div class="time remaining">
                      <label>Time Remaining</label>
                      <p>00:30:00</p>
                  </div>
                  </div>


                  <div class="actbtn">
                    <button mat-stroked-button color="primary" class="start">Start/Pause</button>
                    <button mat-stroked-button color="primary" >Complete</button>
                  </div>

                </div>
            </div>

            </mat-tab>
          
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon">check_box</mat-icon>
                Room Clean
              </ng-template>
          
              <div class="detailholder">
                <div class="tdetail">

                  <div class="lisBlockHolder">
                    <div class="listBlock">

                      <div class="theading">Task</div>
                      <div class="tlist">
                        <button mat-icon-button color="primary" ><mat-icon>task_alt</mat-icon></button> 
                        Check all power in OR room.
                      </div>
                      <div class="tlist">
                        <button mat-icon-button color="basic" ><mat-icon>task_alt</mat-icon></button> 
                        Check all the equipments are working fine.
                      </div>
                      <div class="tlist">
                        <button mat-icon-button color="basic" ><mat-icon>task_alt</mat-icon></button> 
                        Room should be clean.
                      </div>

                    </div>                    

                    <div class="listBlock">
                      <div class="theading">Equipments</div>
                      <div class="tlist">
                        <button mat-icon-button color="primary" ><mat-icon>task_alt</mat-icon></button> 
                        Dermatology Equipment.
                      </div>
                      <div class="tlist">
                        <button mat-icon-button color="basic" ><mat-icon>task_alt</mat-icon></button> 
                        Anaesthesia Machine
                      </div>
                      <div class="tlist">
                        <button mat-icon-button color="basic" ><mat-icon>task_alt</mat-icon></button> 
                        Suction Machine
                      </div>
                    </div>
                  </div>


                  <div class="actbtn">                      
                    <button mat-stroked-button color="primary" (click)="addPasscode(passcode)" >Submit</button>
                    <a href="javascript:void(0)"  (click)="reportIssue(report)" class="report">Report an issue</a>
                    <button mat-button color="warn" class="emergency" >EMERGENCY</button>
                  </div>

                </div>
                <div class="ttimer">

                  <div class="timeHolder">
                    <div class="time">
                      <label>Actual Time Taken</label>
                      <p>00:15:00</p>
                  </div>

                  <div class="time remaining">
                      <label>Time Remaining</label>
                      <p>00:30:00</p>
                  </div>
                  </div>


                  <div class="actbtn">
                    <button mat-stroked-button color="primary" class="start">Start/Pause</button>
                    <button mat-stroked-button color="primary" >Complete</button>
                  </div>

                </div>
            </div>
            </mat-tab>

          </mat-tab-group>
          
    </div>
</div>



<ng-template #report>
  <h2 mat-dialog-title>
      <span class="groupIcon" ><mat-icon>report_problem</mat-icon></span>
      Write Report
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </h2>
  
<mat-dialog-content class="mat-typography"> 
  <mat-form-field appearance="">
    <mat-label>Write Report</mat-label>
    <textarea matInput style="min-height: 150px;" ></textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions >
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary">Report</button>
</mat-dialog-actions>

</ng-template>


<ng-template #passcode>
  <h2 mat-dialog-title>
      <span class="groupIcon" ><mat-icon>vpn_key</mat-icon></span>
      Add Passcode
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </h2>
  
<mat-dialog-content class="mat-typography"> 

  <mat-form-field appearance="">
    <mat-label>Add Passcode</mat-label>
    <input matInput>
  </mat-form-field>

</mat-dialog-content>
<mat-dialog-actions >
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary">Submit</button>
</mat-dialog-actions>
</ng-template>